module.exports = __webpack_public_path__ + "img/92.2b7eddf4.png";